import {
    POPULAR_PLACE_LIST_ACTION, POPULAR_PLACE_LIST_SUCCESS,
    POPULAR_PLACE_DETAIL_ACTION, POPULAR_PLACE_DETAIL_SUCCESS,
    POPULAR_PLACE_DETAIL_CREATE_ACTION, POPULAR_PLACE_DETAIL_UPDATE_ACTION,
} from '../constants/Types';

export const getListPopularPlaces = (filters) => ({ type: POPULAR_PLACE_LIST_ACTION, filters });
export const setListPopularPlaces = (data) => ({ type: POPULAR_PLACE_LIST_SUCCESS, dataList: data.dataList, pageIndex: data.pageIndex, pageSize: data.pageSize, totalCount: data.totalCount  });
export const getPopularPlaceDetail = (id) => ({ type: POPULAR_PLACE_DETAIL_ACTION, id });
export const setPopularPlaceDetail = (popularPlace) => ({ type: POPULAR_PLACE_DETAIL_SUCCESS, popularPlace});

export const updatePopularPlace = (popularPlace) => ({ type: POPULAR_PLACE_DETAIL_UPDATE_ACTION, popularPlace });
export const createPopularPlace = (popularPlace) => ({ type: POPULAR_PLACE_DETAIL_CREATE_ACTION, popularPlace });